module.exports = __webpack_public_path__ + "static/media/doc1.bebebad0.jpg";